export const wpLegacySchemaClass = 'ql-legacy-schema';
